<template>
    <Card>
        <template v-slot:header>
            <h2>实时数据</h2>
            <span class="icon-info">&nbsp;</span>
            <SelectChartValueType @change="onTypeChanged"></SelectChartValueType>
        </template>
        <div class="card-content">
            <ChartMap class="chart-normal" ref="chart"></ChartMap>
        </div>
    </Card>
</template>
<script>
import ChartMap from "../../components/ChartMap.vue";
import SelectChartValueType from "./SelectChartValueType.vue";
export default {
    name: "FlowNow",
    components: {
        SelectChartValueType,
        ChartMap,
    },
    data() {
        return {
            xAxisData: [],
            dataObject: null,
            maxData: 100,
            type: "1",
        };
    },
    mounted() {},
    methods: {
        onTypeChanged(tp) {
            this.type = tp;
            this.bindData();
        },
        bindData() {
            let opt = this.getOptions();
            this.$refs.chart.setData(opt);
        },
        getTypeKey() {
            switch (this.type) {
                case "2":
                    return "FlowDensity";
                case "3":
                    return "Amount";
                case "4":
                    return "OrderRate";
                case "5":
                    return "Price";
                case "6":
                    return "Effect";
                default:
                    return "DataIn";
            }
        },

        setData(data) {
            data.EntityID = data.ID;
            data.EndTime = data.BeginTime;
            data.Date = data.BeginTime;
            data.TotalType = 1;

            this.$ajax.post("/AnalyzeData/GetTotalGroup", data).then((result) => {
                let arrX = [];
                for (let i = 0; i < result.Data.Today.length; i++) {
                    arrX.push(result.Data.Today[i].Name);
                }
                this.xAxisData = arrX;
                this.dataObject = result.Data;
                this.bindData();
            });
        },
        getData(key) {
            let arr = [];
            let keyData = this.getTypeKey();

            for (let i = 0; i < this.dataObject[key].length; i++) {
                arr.push(this.dataObject[key][i][keyData]);
                this.maxData = Math.max(this.maxData, this.dataObject[key][i][keyData]);
            }
            return arr;
        },
        getOptions() {
            let option = {
                color: ["#599bf7", "#ef807c", "#ffc62e", "#ff9631", "#87d14b"],
                title: {},
                tooltip: {
                    show: true,
                    showContent: true,
                    trigger: "axis",
                },
                legend: {
                    data: ["当日", "昨日", "上周同期", "上月同期", "去年同期"],
                    bottom: "0px",
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "40px",
                    containLabel: true,
                },
                toolbox: {
                    feature: {
                        saveAsImage: {},
                    },
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: this.xAxisData,
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                series: [
                    {
                        name: "当日",
                        type: "line",
                        data: this.getData("Today"),
                    },
                    {
                        name: "昨日",
                        type: "line",
                        data: this.getData("Yesterday"),
                    },
                    {
                        name: "上周同期",
                        type: "line",
                        data: this.getData("LastWeek"),
                    },
                    {
                        name: "上月同期",
                        type: "line",
                        data: this.getData("LaskMonth"),
                    },
                    {
                        name: "去年同期",
                        type: "line",
                        data: this.getData("LaskYear"),
                    },
                ],
                yAxis: {
                    type: "value",
                    max: this.maxData,
                },
            };
            return option;
        },
    },
};
</script>
